import { render, staticRenderFns } from "./TomatSearch.vue?vue&type=template&id=2a0ffcc9"
import script from "./TomatSearch.vue?vue&type=script&lang=js"
export * from "./TomatSearch.vue?vue&type=script&lang=js"
import style0 from "./TomatSearch.vue?vue&type=style&index=0&id=2a0ffcc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports